import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { faqs } from "@/mocks/news";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="border-y border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-[0.8fr_1.4fr] lg:gap-16">
        <Reveal className="w-full">
          <div className="lg:sticky lg:top-32">
            <span className="label-font text-xs uppercase tracking-[0.24em] text-primary-600">
              FAQ
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              常见问题
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              关于信息来源、更新节奏和纠错方式，这里给出了最直接的回答。如果还有没覆盖到的问题，可以在页面底部的表单里提问。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-4">
              <p className="flex items-start gap-2 text-xs leading-relaxed text-foreground-600">
                <i className="ri-information-line mt-0.5 text-primary-600" />
                我们只整理公开可查的信息，不涉及私人住址、联系方式与未公开的个人隐私内容。
              </p>
            </div>
          </div>
        </Reveal>

        <div className="w-full space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <Reveal key={faq.q} delay={Math.min(index, 5) * 50}>
                <div
                  className={`overflow-hidden rounded-lg border transition-colors ${
                    isOpen ? "border-primary-300 bg-primary-50/50" : "border-background-200 bg-background-100/70"
                  }`}
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 p-4 text-left md:p-5"
                  >
                    <span className="flex items-start gap-3">
                      <span
                        className={`label-font mt-0.5 shrink-0 text-xs font-semibold ${
                          isOpen ? "text-primary-600" : "text-foreground-400"
                        }`}
                      >
                        Q{String(index + 1).padStart(2, "0")}
                      </span>
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {faq.q}
                      </span>
                    </span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-600">
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="border-t border-background-200 px-4 pb-4 pt-3.5 md:px-5 md:pb-5">
                      <p className="pl-0 text-sm leading-relaxed text-foreground-700 md:pl-9">
                        {faq.a}
                      </p>
                    </div>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}